import { useCallback, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import Close from './Close'
import Left from './Left'
import Right from './Right'
import { galleryNormal } from '../constants/gallery'
import { motion } from 'framer-motion'
import LazyImagePreview from './LazyImagePreview'

enum Keys {
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
}

export default function ImagePreview({
    opened,
    index,
    onCloseClick,
}: {
    opened: boolean
    index: number
    onCloseClick: () => void
}) {
    const [activeIndex, setActiveIndex] = useState(index)

    const handlePrevClick = useCallback(() => {
        if (activeIndex !== null) {
            if (activeIndex <= 0) setActiveIndex(galleryNormal.length - 1)
            else setActiveIndex((prev) => prev - 1)
        }
    }, [activeIndex])

    const handleNextClick = useCallback(() => {
        if (activeIndex !== null) {
            if (activeIndex >= galleryNormal.length - 1) setActiveIndex(0)
            else setActiveIndex((prev) => prev + 1)
        }
    }, [activeIndex])

    const handleKeyEvent = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === Keys.ArrowLeft) handlePrevClick()
            if (event.key === Keys.ArrowRight) handleNextClick()
        },
        [handleNextClick, handlePrevClick]
    )

    useEffect(() => {
        if (opened)
            document.querySelector('body')?.classList.add('overflow-hidden')
        else document.querySelector('body')?.classList.remove('overflow-hidden')
    }, [opened])

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvent)

        return () => {
            document.querySelector('body')?.classList.remove('overflow-hidden')
            document.removeEventListener('keydown', handleKeyEvent)
        }
    }, [handleKeyEvent])

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 100 }}
            transition={{
                duration: 0.3,
            }}
            className="w-screen h-screen flex flex-col items-center justify-center fixed z-10 top-0 left-0 bg-black bg-opacity-80"
        >
            <button
                onClick={onCloseClick}
                className="absolute top-5 md:top-10 right-5 md:right-10 z-20"
            >
                <Close />
            </button>

            <div className="w-full md:hidden">
                {index !== null && (
                    <Swiper initialSlide={index} className="w-full">
                        {galleryNormal.map((item, i) => (
                            <SwiperSlide key={i} className="w-full">
                                <div className="w-full flex items-center justify-center p-4">
                                    {/* <img
                                        src={item.src}
                                        alt={item.alt}
                                        className="w-full max-w-xl"
                                    /> */}
                                    <LazyImagePreview
                                        src={item.src}
                                        alt={item.alt}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </div>

            <div className="w-full hidden md:flex items-center justify-center gap-8">
                <button onClick={handlePrevClick}>
                    <Left />
                </button>
                <div className="w-[36rem] aspect-square">
                    {activeIndex !== null && galleryNormal[activeIndex] && (
                        <img
                            src={galleryNormal[activeIndex].src}
                            alt={galleryNormal[activeIndex].alt}
                            className="w-[36rem] aspect-square"
                        />
                        // <LazyImagePreview
                        //     src={galleryNormal[activeIndex].src}
                        //     alt={galleryNormal[activeIndex].alt}
                        // />
                    )}
                </div>
                <button onClick={handleNextClick}>
                    <Right />
                </button>
            </div>
        </motion.div>
    )
}
